import { auth } from '@features/auth/services/authService';

export const refreshToken = async (): Promise<string> => {
  const user = auth.currentUser;
  if (user) {
    const token = await user.getIdToken(true); // Force refresh
    return token;
  } else {
    throw new Error('No user is currently authenticated');
  }
};
